export default __webpack_public_path__ + "static/media/about13.02169837.jpeg";